<template>
  <div
    :class="[
      'asc-derived-parameter-grid-container',
      disabled ? 'asc-derived-parameter-grid-container--disabled' : '',
    ]"
  >
    <asc-selection-grid
      v-if="!loading"
      :values="values"
      :show-rows-per-page="false"
      :full-columns="true"
      :selected="selected"
      :column-defs="columnDefs"
      :get-row-id="params => params.data.id"
      row-selection="multiple"
      :grid-size="400"
      no-data-message=""
      @onSelectionChanged="handleSelectionChanged"
      @onRowSelected="handleRowSelected"
    ></asc-selection-grid>
    <div v-if="!values.length" class="asc-derivedParametersNoData--wrapper">
      <asc-derived-parameters-no-data
        @openAlertTypeDialog="openAlertTypeDialogHandler"
      ></asc-derived-parameters-no-data>
    </div>
  </div>
</template>

<script>
import AscSelectionGrid from '@/components/molecules/AscSelectionGrid.vue'
import { AscGridPropsMixin, AscGridMethodsMixin } from '@/components/mixins'
import AscDerivedParametersNoData from '@/components/atoms/AscDerivedParametersNoData.vue'

export default {
  name: 'AscDerivedParameterGrid',

  components: {
    AscSelectionGrid,
    AscDerivedParametersNoData,
  },

  mixins: [AscGridPropsMixin, AscGridMethodsMixin],

  props: {
    onSelectionChanged: {
      type: Function,
      default: () => {},
    },
    selected: {
      type: Array,
      default: () => [],
    },
    columnDefs: {
      type: Array,
      required: true,
    },
    deselectAllRows: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    deselectAllRows(newValue) {
      if (newValue) {
        this.agGridOptions.api.deselectAll()
        this.$emit('deselectedAllRows')
      }
    },
  },

  methods: {
    handleRowSelected(selectedNode) {
      this.$emit('onRowSelected', selectedNode)
    },
    handleSelectionChanged(rows) {
      this.$emit('onSelectionChanged', rows)
    },
    openAlertTypeDialogHandler() {
      this.$emit('openAlertTypeDialog')
    },
  },
}
</script>

<style lang="scss">
.asc-derived-parameter-grid-container {
  .asc-derivedParametersNoData--wrapper {
    position: absolute;
    width: 100%;
    left: 0;
    top: 250px;
    padding: 16px;

    .asc-derivedParametersNoData--noData {
      margin: 16px;
    }
  }
}
</style>
